export default __webpack_public_path__ + "static/media/at-office.32c28138.svg";